module.exports = __webpack_public_path__ + "img/13pts12.c91bc81d.png";